import { Component, OnInit, Input } from '@angular/core';
import { IDetailAgendapunt, IDocument } from '../detail-zitting.service';
import { MenuService } from '../../shared/menu.service';
import { IAgendapuntDb, SoortStemming } from '../../shared/offline/cobradb';
import { NgFor, NgIf } from '@angular/common';

@Component({
    selector: 'app-detail-punt',
    templateUrl: './detail-punt.component.html',
    styleUrls: ['./detail-punt.component.scss'],
    standalone: true,
    imports: [NgFor, NgIf]
})
export class DetailPuntComponent implements OnInit {

    private _detail : IDetailAgendapunt;
    private _punt:IAgendapuntDb;
    @Input()
    get detail(): IDetailAgendapunt { return this._detail; }
    set detail(value:IDetailAgendapunt) {
        this._detail = value;
        this.calculateOnbepaald();
    }

    @Input()
    get punt():IAgendapuntDb {return this._punt;}
    set punt(value:IAgendapuntDb) { 
        this._punt=value;
        this.calculateOnbepaald();
    }

    constructor(private menuService:MenuService) { }

    private calculateOnbepaald=()=>{
        const hasData = this._detail && this._punt;
        if (!hasData) {return;}
        if (this.detail.StandpuntToegelaten) {
            this.detail.StandpuntOnbepaald = this.punt.AantalLeden - this.detail.StandpuntAanvaard - this.detail.StandpuntBespreken;
        } else {
            this.detail.Subpunten.forEach(d=>{
                d.StandpuntOnbepaald = this.punt.AantalLeden  - d.StandpuntAanvaard - d.StandpuntBespreken;
            });
        }
    }

    ngOnInit() {
    }

    public showDocument(document:IDocument) {
        this.menuService.openDocument('agendapunt',document.Id,document.Titel,document.Verwijzing);
        return false;
    }

    public getDocumentId = (_:number, document:IDocument) => document.Id;

}
